const PLACEHOLDER_HOSTNAME = "http://example.com";

export const preserveSearchParams = (
    pathAndSearch: string,
    currentSearchParams: URLSearchParams,
): string => {
    const url = new URL(pathAndSearch, PLACEHOLDER_HOSTNAME);

    for (const [key, value] of currentSearchParams.entries()) {
        url.searchParams.set(key, value);
    }

    return url.pathname + url.search;
};
